<template>
  <img
    class="new-loading__icon inline-block"
    :class="{
      'is-loading': isLoading
    }"
    src="https://static.coros.com/coros-v2/images/1986c5a50d9ecb4e10335413f6b2bcc8.svg"
  />
</template>

<script>
export default {
  name: 'NewLoadingIcon',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.new-loading__icon {
  height: px2rem144(40);

  &.is-loading {
    animation: rotate 1s linear infinite;
  }
}
</style>
